import { render, staticRenderFns } from "./CounterLoader.vue?vue&type=template&id=1b9ed2fc&scoped=true"
import script from "./CounterLoader.vue?vue&type=script&lang=js"
export * from "./CounterLoader.vue?vue&type=script&lang=js"
import style0 from "./CounterLoader.vue?vue&type=style&index=0&id=1b9ed2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9ed2fc",
  null
  
)

export default component.exports